import {TargetElement} from '../configs/TargetElement';
import {CreatorMetaData} from './CreatorMetaData';

export type ElementInitCallBack = { name: string, obj: any, targetElement: TargetElement, creatorMetaData: CreatorMetaData };